import { Component, Input } from '@angular/core';


@Component({
  selector: 'bidi-editable-content',
  templateUrl: './editable-content.component.html',
  styleUrls: ['./editable-content.component.scss']
})
export class EditableContentComponent  {
  @Input() resource;
  @Input() selected = false;
  showPreview = false;
  noCategory = 'Sin categoria';

  openPreview() {
    this.showPreview = true;
    console.log('open it!');
  }
  closePreview(e) {
    this.showPreview = e;
    console.log(e);
  }



}
